import { AxiosInstance } from "axios";
import { ConfigDocumentModel } from "models/ConfigDocumentModel";
import { TemplatesTableViewModel } from "models/TemplatesTableViewModel";

export class TemplatesApi {
  constructor(private axios: AxiosInstance) {}

  async getTemplates(boardId: string | number, signal?: AbortSignal): Promise<ConfigDocumentModel[]> {
    const response = await this.axios.get<ConfigDocumentModel[]>(`api/boards/${boardId}/templates`, { signal });
    return response.data;
  }

  async uploadTemplate(boardId: string | number, file: File, language?: string): Promise<{ blobName: string }> {
    const form = new FormData();
    form.append("uploadFile", file);
    if (language) {
      form.append("language", language);
    }
    const response = await this.axios.post<{ blobName: string }>(`api/boards/${boardId}/templates`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async removeTemplate(boardId: string | number, path: string): Promise<boolean> {
    const response = await this.axios.delete<boolean>(`api/boards/${boardId}/templates`, {
      params: { path },
    });
    return response.data;
  }

  async getValidTemplateNames(signal?: AbortSignal): Promise<string[]> {
    const response = await this.axios.get<string[]>(`api/templates/validNames`, { signal });
    return response.data;
  }

  async getBoardTemplatesTable(boardId: string | number, signal?: AbortSignal): Promise<TemplatesTableViewModel> {
    const response = await this.axios.get<TemplatesTableViewModel>(`api/templates/table/${boardId}`, { signal });
    return response.data;
  }

  async getDefaultTemplates(signal?: AbortSignal): Promise<ConfigDocumentModel[]> {
    const response = await this.axios.get<ConfigDocumentModel[]>(`api/templates`, { signal });
    return response.data;
  }

  async getDefaultTemplatesTable(signal?: AbortSignal): Promise<TemplatesTableViewModel> {
    const response = await this.axios.get<TemplatesTableViewModel>(`api/templates/table`, { signal });
    return response.data;
  }
}
